import { TreeViewNode } from "../components/TreeView/treeViewNode";
import { ParameterData } from "./parameterData";
import { ReturnData } from "./returnData";
export class FunctionData {
    constructor() {
        //All classes
        this.id = "";
        this.name = "";
        this.parameters = new Array();
        this.return = null;
        this.description = "";
        this.example = "";
        this._treeViewNode = null;
    }
    deserialize(input) {
        this.id = input.id;
        this.name = input.name;
        if (input.parameters) {
            for (const jsonParameter of input.parameters) {
                let parameterData = new ParameterData().deserialize(jsonParameter);
                this.parameters.push(parameterData);
            }
        }
        if (input.return) {
            this.return = new ReturnData().deserialize(input.return);
        }
        this.description = input.description;
        this.example = input.example;
        return this;
    }
    getTreeViewNode() {
        if (!this._treeViewNode) {
            const children = new Array();
            //Parameters
            let parametersText = "";
            if (this.parameters.length > 0) {
                const parameters = new Array();
                for (const parameterData of this.parameters) {
                    parameters.push(new TreeViewNode(parameterData.name /*+ ":" + parameterData.type*/, parameterData.description, []));
                    if (parametersText.length > 0) {
                        parametersText += ", ";
                    }
                    parametersText += parameterData.name; /*+ ":" + parameterData.type*/
                }
                children.push(new TreeViewNode("Parameters", "", parameters));
            }
            //Return
            //let returnText:string = ""
            if (this.return != null) {
                children.push(this.return.getTreeViewNode());
                //returnText = ":" + this.return.type
            }
            //Example
            if (this.example) {
                children.push(new TreeViewNode("Example", this.example, []));
            }
            this._treeViewNode = new TreeViewNode(this.name + "(" + parametersText + ")" /*+ returnText*/, this.description, children);
        }
        return this._treeViewNode;
    }
}
